import { jsx as e } from "react/jsx-runtime";
import { useMergeRefs as l, FloatingPortal as a } from "@floating-ui/react";
import { forwardRef as m } from "react";
import { cn as f } from "../../utils/cn.js";
import { useTooltipContext as d } from "./tooltipContext.js";
const C = "z-50 max-w-xs rounded bg-gray-900 px-2 py-1 text-sm text-white shadow-md dark:bg-gray-700", w = m(function({ style: n, className: r, ...o }, i) {
  const t = d(), s = l([t.refs.setFloating, i]);
  return t.isMounted ? /* @__PURE__ */ e(a, { children: t.isMounted && (o.open == null || o.open) && /* @__PURE__ */ e(
    "div",
    {
      ref: s,
      className: f("z-50", r),
      style: {
        zIndex: 9999,
        ...t.floatingStyles,
        ...n,
        ...t.transitionStyles
      },
      ...t.getFloatingProps(o)
    }
  ) }) : null;
});
export {
  w as TooltipContent,
  C as tooltipContentClassName
};
